import AlertBase, { AlertLinks } from 'cookie-banner/base/AlertBase'

export class TeachableAlert extends AlertBase {
  override async loadCompanyStyle(): Promise<void> {
    await require('./style.css')
  }

  override bannerLinks(): AlertLinks {
    return {
      cookiePolicyUrl: 'https://teachable.com/cookies-policy',
      dataPrivacyUrl: 'https://teachable.com/privacy-policy'
    }
  }
}
